// extracted by mini-css-extract-plugin
module.exports = {"trustedRetailerBanner":"Kg","trustedRetailerTooltipWrapper":"Lg"};